// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EBbCIm2CTsIapmEaYuqa{min-width:492px;margin-top:40px}.VsBrGJ4jucSCGoSXuYLs{margin-top:16px}.EDjINIABhAkiS3srvpG_{padding:11px 8px 11px 11px}.u_leyKC2KZg4dRd6_4Xv{height:51px}.X4rSXqaK2IYjr6zQOVKN{align-items:center;display:flex}.fl4GV3MjPQRjWg1aNNgl{flex-direction:column;gap:4px;padding:8px 12px;display:flex}.qs_9Zm8UTMg4NWccpdYb{background:var(--black-10);width:32px;height:32px;color:var(--content-primary-secondary);border-radius:6px;justify-content:center;align-items:center;display:flex}.IcPl5OwpoRsC0RDW0Out{text-decoration:none}.QfSK2rSqzYkj_foJ7JDk{margin-bottom:24px}.dMdR5Y0CSQYGKZkPPk0p{display:none}.jjquvbFK14Ihvwq8CHUj{cursor:pointer;justify-content:space-between;align-items:center;padding:8px 12px;display:flex}.jjquvbFK14Ihvwq8CHUj:hover{background:var(--background-neutral-subtle)}.zaIYHu_otL0CYCeuU_8U{background:var(--white-100);z-index:var(--zIndex-BASE_10);margin-top:32px;padding-top:0;position:-webkit-sticky;position:sticky;bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `EBbCIm2CTsIapmEaYuqa`,
	"selectWrap": `VsBrGJ4jucSCGoSXuYLs`,
	"select": `EDjINIABhAkiS3srvpG_`,
	"option": `u_leyKC2KZg4dRd6_4Xv`,
	"optionWrap": `X4rSXqaK2IYjr6zQOVKN`,
	"optionWrap__info": `fl4GV3MjPQRjWg1aNNgl`,
	"optionWrapInfo": `fl4GV3MjPQRjWg1aNNgl`,
	"optionWrap__iconBox": `qs_9Zm8UTMg4NWccpdYb`,
	"optionWrapIconBox": `qs_9Zm8UTMg4NWccpdYb`,
	"alertAction": `IcPl5OwpoRsC0RDW0Out`,
	"alert": `QfSK2rSqzYkj_foJ7JDk`,
	"hiddenOption": `dMdR5Y0CSQYGKZkPPk0p`,
	"addUseCaseLaterWrap": `jjquvbFK14Ihvwq8CHUj`,
	"nextButton": `zaIYHu_otL0CYCeuU_8U`
};
export default ___CSS_LOADER_EXPORT___;
